import { Spin, Table, TableProps } from "antd";
import { useTranslation } from "react-i18next";

import ArrowDown from "./icons/ArrowDown";
import styles from "./style.module.scss";
import "./style.scss";

const CustomTable = ({
  tableProps,
  hasMoreProps,
}: {
  tableProps: TableProps;
  hasMoreProps?: {
    hasMore?: boolean;
    loadMore?: () => void;
    showInifineScroll?: boolean;
    isLoading?: boolean;
  };
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.customTable}>
      <Table {...tableProps} pagination={false} className="custom-table" />
      {hasMoreProps?.showInifineScroll ? (
        hasMoreProps?.isLoading ? (
          <div style={{ textAlign: "center", padding: "16px 0" }}>
            <Spin />
          </div>
        ) : hasMoreProps?.hasMore ? (
          <div className={styles.showMore} onClick={hasMoreProps?.loadMore}>
            {t("normal.show.more")}
            <ArrowDown />
          </div>
        ) : (
          <div className={styles.showMore} style={{ cursor: "default" }}>
            {t("normal.no.more")}
          </div>
        )
      ) : (
        ""
      )}
    </div>
  );
};

export default CustomTable;
